import { Background } from "@humanex/ui/components";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4">
      <Background className="z-[-1]" />
      <Outlet />
    </div>
  );
}
